/**
 *
 * 	Gestione effetto numeratore
 *
 */

let easing = {
    quadratic: (x) => {
        return Math.sqrt(x);
    },
};

const range = (start, stop, step) => {
    let array = [];
    for (let i = start; i < stop; i += step) array.push(i);
    return array;
};

const interpolation = (fps, easing, finalValue) => {
    const scaleIt = (value) => {
        return finalValue * value;
    };

    let x = range(0, 1, 1 / fps),
        y = x.map(easing).map(scaleIt);

    return y;
};

const animateEl = (values, duration, onAnimate) => {
    let frameIndex = 0,
        fps = values.length,
        id = setInterval(anime, duration / fps);

    function anime() {
        let current = values[frameIndex],
            isLastFrame = frameIndex === fps - 1;

        onAnimate(current, frameIndex, values);

        if (isLastFrame) {
            clearInterval(id);
        } else {
            frameIndex++;
        }
    }
};

const round = (value, decimals) => {
    return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};

const unformat = (content) => {
    let unlocalized = content.replace(".", "").replace(",", "."),
        value = parseFloat(unlocalized);
    return value;
};

const format = (value) => {
    return value.toString().replace(".", ",");
};

const counterAnimation = (el) => {
    let fps = 50;

    let content = el.firstChild.textContent.trim(),
        decimalPlaces = content.split(",")[1] || "",
        value = unformat(content),
        values = interpolation(fps, easing.quadratic, value);

    animateEl(values, 2500, function (current, i, values) {
        let isLast = i === values.length - 1,
            value = round(current, decimalPlaces.length);
        el.firstChild.textContent = isLast ? content : format(value);
    });
};

export default counterAnimation;
